import React from 'react';
import Cnavbar from '../components/JSX/Cnavbar';
import Slider8 from '../components/JSX/Slider8';
import Message from '../components/JSX/Message';
import FAQ from '../components/JSX/FAQ';
import Footerc from '../components/JSX/Footerc';

const Contact = () => (
  <>
    <Cnavbar />
    <Slider8 />
    <Message/>
    <FAQ/>
    <Footerc/>
  </>
);

export default Contact

